<template>
    <div>
        <div
            v-if="treatment === 'topUni'"
            class="font-works-sans text-2xl leading-7 md:text-6xl lg:text-8xl md:leading-12 lg:leading-14"
        >
            <CountUpItemNumber
                :end="universityStats.users || 0"
                :should-start="startUniUsersCount"
                :options="{
                    separator: t('registration.countersSeparator'),
                }"
            />
            <span>{{ header }}</span>
        </div>

        <h1
            v-else
            :class="[
                treatment === 'download' ? '' : 'lg:font-display-2',
                'font-display-4 md:font-display-3 text-4xl break-words',
            ]"
        >
            {{ header }}
        </h1>

        <p class="mx-auto mt-2 leading-6 text-slate-600 md:text-white md:text-lg md:max-w-lg lg:text-3xl lg:leading-11">
            {{ subheader }}
        </p>

        <div
            v-show="screenSize === 'large'"
            class="pt-13"
        >
            <div v-if="treatment === 'topUni'">
                <span>{{ t('registration.topUni.statsHeader') }}</span>
                <span class="font-medium break-words">{{ currentUniversity.name }}</span>
                <UniversityStats
                    class="justify-between hidden max-w-md mx-auto lg:flex mt-5"
                    size="sm"
                />
            </div>
            <Platformstats
                v-else
                class="justify-between hidden max-w-md mx-auto lg:flex mt-13"
                size="sm"
            />
        </div>
    </div>
</template>

<script>
import Platformstats from '@components/Platformstats';
import UniversityStats from '@components/UniversityStats';
import CountUpItemNumber from '@components/CountUpItemNumber';
import { mapGetters } from 'vuex';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'RegistrationHeader',
    components: {
        Platformstats,
        UniversityStats,
        CountUpItemNumber,
    },
    props: {
        treatment: {
            type: String,
            required: false,
            default: 'general',
        },
    },
    setup() {
        const { t } = useTranslation('authentication');
        return { t };
    },
    data() {
        return {
            startUniUsersCount: false,
        };
    },
    computed: {
        ...mapGetters('university', ['currentUniversity', 'universityStats']),
        ...mapGetters('ui', ['screenSize']),
        header() {
            switch (this.treatment) {
                case 'download':
                    return this.t('registration.download.headline');
                case 'topUni':
                    return this.t('registration.topUni.headline');
                case 'normalUni':
                    return this.t('registration.normalUni.headline', {
                        uniName: this.currentUniversity.name,
                    });
                case 'general':
                    return this.t('registration.general.headline');
                default:
                    return this.t('registration.general.headline');
            }
        },
        subheader() {
            switch (this.treatment) {
                case 'download':
                    return this.t('registration.download.subheader');
                case 'topUni':
                    return this.t('registration.topUni.subheader', {
                        uniName: this.currentUniversity.name,
                    });
                case 'normalUni':
                    return this.t('registration.normalUni.subheader');
                case 'general':
                    return this.t('registration.general.subheader');
                default:
                    return this.t('registration.general.subheader');
            }
        },
    },
    watch: {
        universityStats(newValue) {
            if (newValue) {
                this.startUniUsersCount = true;
            }
        },
    },
    mounted() {
        if (this.universityStats.users > 0 && !this.startUniUsersCount) {
            this.startUniUsersCount = true;
        }
    },
};
</script>
